<div fxLayout="row wrap" fxLayoutAlign="start center">
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxFlex="340px" fxFlex.lt-lg="100">
    <form [formGroup]="searchFormGroup" fxFlex="140px" fxFlex.lt-lg="100">
      <mat-form-field appearance=outline class="input-form">
        <mat-label>{{zyuushoInfo.postno.labelName}}</mat-label>
        <input matInput autocomplete="off" [OnlyNumber]=true [errorStateMatcher]="matcher"
          [formControlName]="zyuushoInfo.postno.formControlName" placeholder="Ex. 0000000"
          class="font-color-display-only" />
      </mat-form-field>
      <div fxLayout="row wrap" fxLayoutAlign="center center" fxFlex="140px" fxFlex.lt-lg="100">
        <button type="button" id="zyuushoSearch" (click)="onClickZyuushoSearch()" fxFlex="100px" mat-raised-button color="primary"
          style="width: 50%; margin-top: 10px; margin-left: 40px; margin-bottom: 20px;">検索</button>
      </div>
    </form>
  </div>
  <form [formGroup]="parentFormGroup" fxFlex="520px" fxFlex.lt-md="100">
    <mat-form-field appearance=outline class="input-form">
      <mat-label>{{zyuushoInfo.addrcd.labelName}}</mat-label>
      <mat-select [formControlName]="zyuushoInfo.addrcd.formControlName" #selectZyuushoCode autocomplete="off"
        class="disabled-select-color">
        <mat-option value="" selected></mat-option>
        <mat-option *ngFor="let type of addrcdList" [value]="type.value">{{type.viewValue}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>

<div id="errorMessage" *ngIf="errorMessage != ''" fxLayout="row wrap" fxLayoutAlign="start center">
  <p style="margin-left: 40px; color: red">{{errorMessage}}</p>
</div>

<form [formGroup]="parentFormGroup">
  <div fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance=outline class="input-form" fxFlex="125px" fxFlex.lt-lg="100">
      <mat-label>{{zyuushoInfo.banti.labelName}}</mat-label>
      <input matInput autocomplete="off" [OnlyNumber]=true [errorStateMatcher]="matcher"
        [formControlName]="zyuushoInfo.banti.formControlName" placeholder="Ex. 1" class="font-color-display-only" />
    </mat-form-field>

    <mat-form-field appearance=outline class="input-form" fxFlex="125px" fxFlex.lt-lg="100">
      <mat-label>{{zyuushoInfo.gou.labelName}}</mat-label>
      <input matInput autocomplete="off" [OnlyNumber]=true [errorStateMatcher]="matcher"
        [formControlName]="zyuushoInfo.gou.formControlName" placeholder="Ex. 1" class="font-color-display-only" />
    </mat-form-field>
  </div>

  <div fxLayout="row wrap" fxLayoutAlign="start center">
    <mat-form-field appearance=outline class="input-form" fxFlex="400px" fxFlex.lt-lg="100">
      <mat-label>{{zyuushoInfo.supadrKananm.labelName}}
      </mat-label>
      <input matInput autocomplete="off" [errorStateMatcher]="matcher"
        [formControlName]="zyuushoInfo.supadrKananm.formControlName" placeholder="Ex. マルマルマンションイチゴウトウイチマルイチゴウシツ"
        class="font-color-display-only" />
    </mat-form-field>
    <mat-form-field appearance=outline class="input-form" fxFlex="400px" fxFlex.lt-lg="100">
      <mat-label>{{zyuushoInfo.yagouKananm.labelName}}
      </mat-label>
      <input matInput autocomplete="off" [errorStateMatcher]="matcher"
        [formControlName]="zyuushoInfo.yagouKananm.formControlName" placeholder="Ex. マルマルショウテン"
        class="font-color-display-only" />
    </mat-form-field>
  </div>

</form>